module.exports = __webpack_public_path__ + "static/img/mcculloch-sam.29391e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mcculloch-sam.jpg
// module id = 01+1
// module chunks = 0